module.exports = __webpack_public_path__ + "img/21.901fd154.jpg";